// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

require('../js/bootstrap');

import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification';
import datepicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment-timezone';
import VueBrowserUpdate from 'vue-browserupdate';
import Multiselect from 'vue-multiselect'

import App from '../js/App.vue'
import store from './store'
import router from './router'
import i18n from '../js/services/locale'
import "../js/services/vee-validate";
import {errorResponseHandler} from "../js/services/errorHandler";

import mainOidc from "./auth";


Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuex);
Vue.use(VueI18n);

Vue.use(Notifications);
Vue.use(datepicker);
Vue.use(VueBrowserUpdate, {
    options: {},
    test: false,
});

Vue.prototype.moment = moment
Vue.prototype.$xstore_url = process.env.MIX_XSTORE_URL || 'https://xstore.rch.it';
Vue.prototype.$xdealer_url = process.env.MIX_XDEALER_URL || 'https://xdealer.rch.it';
Vue.prototype.$xmarket_url = process.env.MIX_XMARKET_URL || 'https://xmarket.rch.it';
Vue.prototype.$support_url = process.env.MIX_SUPPORT_URL || 'https://support.rch.it';
Vue.prototype.$rchpay_url = process.env.MIX_RCHPAY_URL || 'https://www.rch.it/servizi/pagamenti-digitali/rch-pay/';
Vue.prototype.$smartorder_url = process.env.MIX_SMARTORDER_URL || 'https://smartorder.rch.it';
Vue.prototype.$smartplanner_url = process.env.MIX_SMARTPLANNER_URL || 'https://smartplanner.rch.it';
Vue.prototype.$ats_admin_url = process.env.MIX_ATS_ADMIN_URL || 'https://ats-admin.rch.it';
Vue.prototype.$customer_portal_sso_url = process.env.MIX_CUSTOMER_PORTAL_SSO_URL || 'https://rchspa.my.site.com';

Vue.filter('formatPriceExt', function (value, currency = null, dec = 2) {
  if (!value && value !== 0) return 0;
  let val = (value / 1000).toFixed(dec).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')+(currency ? " "+currency : "")
})

Vue.filter('formatDate', function(value, timezone = null, format = null) {
  if (value) {
    let date = moment.utc(String(value))
    if(timezone && timezone.name) date.tz(timezone.name);
    return date.format(format !== null && typeof format !== 'undefined' ? format : 'DD/MM/YYYY HH:mm:ss');
  }
});
Vue.filter('formatDoctrineDate', function(value, timezone = null, format = null) {
  if (value && value.date && value.timezone) {
    if(timezone) value.timezone = timezone.name;
    let date = moment.utc(String(value.date), "YYYY-MM-DD HH:mm:ss.SSSS").tz(value.timezone).format(format !== null && typeof format !== 'undefined' ? format : 'DD/MM/YYYY HH:mm:ss');
    return date;
  }
});
Vue.filter('formatPrice', function(value, dec_places) {
  if (value) {
    return value.toFixed(dec_places || 2);
  }
});
Vue.component('multiselect', Multiselect)

String.prototype.ucfirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

// Configure Axios
Vue.prototype.$http = axios;
Vue.prototype.$http.default.baseURL = 'https://google.com/api';
Vue.prototype.$http.interceptors.response.use(
    (response) => response,
    errorResponseHandler
);

mainOidc.useRouter(router);
mainOidc.startup().then((ok) => {
    if (ok) {

        /* eslint-disable no-new */
        const app = new Vue({
            el: '#app',
            i18n,
            store,
            router,
            template: '<App/>',
            components: {
                App
            },
            data: () => ({
                alerts: null,
            }),
            created: async function () {
                this.guessLanguage();
                this.loadTranslations();
                store.commit('account/set_group', 'customer');
            },
            methods: {
                guessLanguage: function () {
                    // Load language code from path
                    const path = window.location.pathname.split('/');
                    if (path[1] && path[1].length === 2) {
                        localStorage.setItem('language', path[1]);
                    }
                },
                loadTranslations: function () {
                    const lang = localStorage.getItem('language');
                    if (lang) {
                        store.dispatch('account/updateLanguage', lang).then(() => {
                        })
                    }
                },
            }
        });
    } else {
        console.error("Oidc: Startup was not ok");
    }
});
